import Navbar from "@/layout/navbar/NavBar";
import "./index.css";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import routes from "@/router";
import PageNotFound from "@/pages/PageNotFound";
import ScrollToTop from "@/components/ScrollToTop";
import GoogleTagManager from "@/hooks/GoogleTagManager";

function App() {
	return (
		<Router>
			<ScrollToTop />
			<GoogleTagManager />
			<div className="relative">
				<Navbar />
				<Routes>
					{routes.map((route) => {
						if (route.children) {
							return (
								<Route key={route.id} path={route.path}>
									{route.children.map((childRoute) => (
										<Route
											key={childRoute.id}
											index={childRoute.index}
											path={childRoute.path}
											element={childRoute.element}
										/>
									))}
								</Route>
							);
						}
						return (
							<Route key={route.id} path={route.path} element={route.element} />
						);
					})}
					<Route path="*" element={<PageNotFound />} />
				</Routes>
			</div>
		</Router>
	);
}

export default App;
